var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('big-list-layout',{attrs:{"slice":_vm.sliceData,"get-pros":_vm.dataType === 'pros' ? _vm.getPros : undefined,"table-data":_vm.dataType === 'table-data' ? _vm.tableData : undefined}})}
var staticRenderFns = []

export { render, staticRenderFns }